export default __webpack_public_path__ + "static/media/appleLogin.25d50c5e.svg";